module.exports = __webpack_public_path__ + "static/logo-8f8512cd5998e6945748b169d540a1be.svg";